import { useEffect, useState } from 'react';
import imageCache from '../utils/imageCache';
import Loading from './Loading/Loading';

/**
 * PageLoader - Wrapper component for page-level loading with image preloading
 * Handles loading states and preloads critical images
 */
const PageLoader = ({ 
  children, 
  loading = false, 
  loadingMessage = '',
  preloadImages = [],
  minLoadTime = 0,
  fullScreen = false,
  onLoadComplete
}) => {
  const [isLoading, setIsLoading] = useState(loading);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!loading) return;

    let isMounted = true;
    const handleLoading = async () => {
      try {
        if (preloadImages.length > 0) {
          await imageCache.preloadBatch(preloadImages);
        }
        if (isMounted && onLoadComplete) {
          onLoadComplete();
        }
      } catch (error) {
        console.warn('Page loading completed with some errors:', error);
        if (isMounted && onLoadComplete) {
          onLoadComplete(error);
        }
      }
    };

    handleLoading();
    return () => {
      isMounted = false;
    };
  }, [loading, preloadImages, onLoadComplete]);

  if (isLoading) {
    return (
      <Loading
        size="medium"
        message={loadingMessage}
        fullScreen={fullScreen}
        className="py-12"
      />
    );
  }

  return children;
};

export default PageLoader;